import { toStatusType } from 'App/rtk';
import { useToastStatus } from 'commons/hooks';
import { useUnlinkPartnerMutation } from 'domains/Configurations/Users/usersApi';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

interface UseUnlinkPartnerResult {
  executeUnlink: () => Promise<void>;
  isLoading: boolean;
}

const useUnlinkPartner = (onClose: () => void): UseUnlinkPartnerResult => {
  const [unlinkPartner, { isLoading, status }] = useUnlinkPartnerMutation();
  const t = useTranslationConfigurations('partnersListComponent');

  useToastStatus({
    status: toStatusType(status),
    success: t('unlinkPartnerModal.toast.success'),
    error: t('unlinkPartnerModal.toast.error'),
    onSuccess: onClose,
  });

  const executeUnlink = async () => {
    await unlinkPartner().unwrap();
  };

  return {
    executeUnlink,
    isLoading,
  };
};

export default useUnlinkPartner;
